export default __webpack_public_path__ + "static/media/favonius_greatsword.bfd288be.png";